import { useLazyQuery } from '@apollo/client'
import { IEnrollment, ISchoolProduct } from '@dtos/Enrollment'
import { IGraphqlQueryProps } from '@dtos/Pagination'
import { GET_ADMIN_PREVIEW_PRODUCTS } from '@services/api/graphql/queries/getAdminPreviewProducts'

interface IUseGetAdminPreviewProductsProps extends IGraphqlQueryProps {}

/**
 * Produtos que o produtor pode visualizar como aluno, na forma de matrícula —
 * a home e o ProductCard só sabem ler IEnrollment.
 *
 * `id` recebe o id do PRODUTO, não null: a MyProductsSection faz
 * `item.id.toString()` em seis pontos (key, cardId, enrollmentId) e null
 * derrubava a home. Não vaza para URL nenhuma: em preview o coursePaths ignora
 * o enrollmentId e monta /admin_view/courses/:courseId.
 *
 * `progressCard` fica null de propósito — em preview não existe progresso, e é
 * isso que faz o card aparecer como não iniciado.
 */
export const toPreviewEnrollment = (product: ISchoolProduct): IEnrollment =>
  ({
    id: product.id,
    progressCard: null,
    schoolProduct: product,
    livemeetRoomsAvailable: [],
  }) as unknown as IEnrollment

export const useGetAdminPreviewProducts = ({
  offset,
  limit,
}: IUseGetAdminPreviewProductsProps) => {
  const [getAdminPreviewProducts, { data, loading, error, called }] =
    useLazyQuery(GET_ADMIN_PREVIEW_PRODUCTS, {
      variables: { offset, limit },
      fetchPolicy: 'cache-and-network',
    })

  return { getAdminPreviewProducts, data, loading, error, called }
}
